import { backendApi } from "@/services/api";
import type { Company } from "./company";

const companyApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    companyList: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/companies/company`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: ["Company"],
    }),
    getCompany: build.query<Company, GetRequest>({
      query: (request) => ({
        url: `/companies/company/${request.id}`,
        method: "GET",
      }),
      providesTags: ["Company"],
    }),
    putCompany: build.mutation<Company, PutRequest>({
      query: (request) => ({
        url: `/companies/company`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Company"],
    }),
  }),
});

export const {
  useCompanyListQuery,
  useGetCompanyQuery,
  usePutCompanyMutation,
} = companyApi;

export interface PutRequest {
  id: string;
  name: string;
  email: string;
  phone: string;
}

export interface GetRequest {
  id: string;
}

export interface ListRequest {
  limit: number;
  offset: number;
}

export interface List {
  count: number;
  items: Company[];
}
